import { useSnapshot } from "valtio";
import { FlowState } from "../../stores/flowStore";
export const useIsFlowActive = flowType => {
  const {
    flow
  } = useSnapshot(FlowState);
  return flow?.type === flowType;
};